import { useHostContext } from 'src/core/hooks/useHostContext';
export function useViewAsStudentUrl(page) {
    const { membershipSlug, product } = useHostContext();
    return `${process.env.APP_CONSUMER_URL}/club/${membershipSlug}/products/${product.id}/${page.type}/${page.id}`;
}
